import React from "react";

export const Input = ({
  title,
  type = "text",
  name,
  value,
  options = [],
  handleChange,
  sectionStyles,
  className,
  divClassName = "",
  error,
  checked,
  min,
  rows,
  onKeyDown,
}) => {
  const inputId = `input-${name}`; // Generate a unique ID for each input
  const fullWidthClass = type !== "checkbox" || type !== "radio";
  const textAreaClass = type === "textarea" ? "flex-col items-start" : "items-center";

  return (
    <div className={`${fullWidthClass ? "flex flex-col md:w-full" : ""} ${divClassName}`}>
      <div className={`flex ${textAreaClass}`}>
        {/* Label */}
        <label htmlFor={inputId} className={sectionStyles}>
          {title}
        </label>

       {/* Render Radio Buttons */}
       {["radio", "checkbox"].includes(type) && options.length > 0 ? (
        <div className="flex flex-wrap gap-4 mt-2">
          {options.map((option) => (
            <label
              key={option.value}
              htmlFor={`${inputId}-${option.value}`}
              className="flex items-center space-x-2"
            >
              <input
                id={`${inputId}-${option.value}`}
                type={type}
                name={name}
                value={option.value}
                onChange={handleChange}
                checked={
                  type === "radio"
                    ? value === option.value
                    : value?.includes(option.value) // For checkboxes, check if value is in array
                }
                className={className}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      ) : type === "textarea" ? (
        <textarea
          id={inputId}
          name={name}
          value={value}
          onChange={handleChange}
          rows={rows || 4}
          className={className}
          aria-invalid={!!error}
          aria-describedby={error ? `${inputId}-error` : undefined}
        />
      ) : (
        // Render Other Input Types
        <input
          id={inputId}
          type={type}
          name={name}
          value={value}
          min={min}
          onChange={handleChange}
          className={className}
          aria-invalid={!!error}
          onKeyDown={onKeyDown}
          aria-describedby={error ? `${inputId}-error` : undefined}
        />
      )}
      </div>
      {/* Error Message */}
      {error && (
        <p
          id={`${inputId}-error`}
          className="text-red-500 text-sm mt-1"
          role="alert"
        >
          {error}
        </p>
      )}
    </div>
  );
};
